import { CrownFillIcon, CrownIcon } from '@zep-us/zus-icons';
import cns from 'classnames';
import Link from 'next/link';
import { useViewportDevice } from '@zep/react';
import { SpaceUserRole, SpaceUserRoleName } from '../../../consts';
import S from './ThumbnailCard.module.scss';
export const ThumbnailCard = ({
  thumbnailImg,
  spaceHashId,
  useThumbnailClick = true,
  myRole,
  children
}: ThumbnailCardProps) => {
  const {
    isMobile
  } = useViewportDevice();
  const iconSize = isMobile ? 12 : 16;
  return <div className={S.container} data-sentry-component="ThumbnailCard" data-sentry-source-file="ThumbnailCard.tsx">
      <Link href={`/play/${spaceHashId}`} passHref legacyBehavior prefetch={false} data-sentry-element="Link" data-sentry-source-file="ThumbnailCard.tsx">
        <a className={S.link} aria-disabled={!useThumbnailClick ? 'true' : 'false'} onClick={e => !useThumbnailClick && e.preventDefault()}>
          <div className={S.thumbnail_wrapper}>
            {}
            <img className={S.thumbnail} src={thumbnailImg} style={useThumbnailClick ? {
            cursor: 'pointer'
          } : undefined} alt="Thumbnail" onError={e => e.currentTarget.src = '/images/light/spaceMe/no_thumbnail_image.png'} width={540} height={340} />
            {myRole >= SpaceUserRole.STAFF && <div className={cns(S.mark_wrapper, myRole === SpaceUserRole.STAFF && S.mark_wrapper_staff)}>
                {myRole === SpaceUserRole.OWNER && <CrownFillIcon width={iconSize} height={iconSize} />}
                {myRole === SpaceUserRole.ADMIN && <CrownIcon width={iconSize} height={iconSize} />}
                <span className={S.mark_label}>
                  {SpaceUserRoleName[myRole]}
                </span>
              </div>}
          </div>
        </a>
      </Link>
      {children}
    </div>;
};
type ThumbnailCardProps = {
  thumbnailImg: string;
  spaceHashId: string;
  useThumbnailClick?: boolean;
  myRole: (typeof SpaceUserRole)[keyof typeof SpaceUserRole];
  children: React.ReactNode;
};